import React from 'react';

const ServicesSection = () => {
  const dataSmnList = [
    {
      title: 'Social Media Management',
      image: 'https://i.ibb.co.com/k2YmwsG0/social.png',
      description: 'Perencanaan konten yang efektif, menulis teks yang tepat, membalas DM anda, tren dinamis di antara Gen-Z, dan hal-hal kecil dan detail lainnya untuk media sosial anda, biarkan kami yang melakukannya.',
    },
    {
      title: 'Creative Content',
      image: 'https://i.ibb.co.com/HLtSk6gc/creative.png',
      description: 'Mereka mengatakan `Konten adalah Raja...<br>Ya, anda bisa setuju atau tidak setuju, tetapi keterlibatan memang penting! Jangan khawatir, kami menggabungkan pengalaman, pengetahuan, dan data kami untuk membuat konten (dan keterlibatan) yang sesuai untuk anda.',
    },
    {
      title: 'Digital Marketing Strategy',
      image: 'https://i.ibb.co.com/tpnNN2Gg/strategy.png',
      description: 'Baik itu SEO (Search Engine Optimization), Social Media Marketing (SMM), atau aktivitas marketing apa pun di internet, kami akan membantu anda mendefinisikan kembali strategi marketing yang sesuai untuk memastikan perusahaan anda mencapai target market yang sesuai.',
    },
    {
      title: 'Brand Campaign',
      image: 'https://i.ibb.co.com/KxCPzKRN/audience.png',
      description: 'Kampanye brand dapat diartikan seperti pakaian superhero untuk produk anda. Ini adalah upaya terkoordinasi untuk menampilkan kekuatan unik dari brand anda dan solusi di benak audiensnya. Dengan pesan yang menarik dan creative approach, brand anda bisa menjadi pahlawan yang memikat hati, pikiran, dan dompet para pelanggan!',
    },
  ];

  return (
    <section id="services" className="tw-py-16 md:tw-py-24 tw-bg-[#f5f5f5]">
      <div className="tw-container tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        <div className="tw-text-center tw-mb-16">
          <h2 className="tw-text-3xl md:text-5xl tw-font-bold tw-text-dark tw-mb-4 title-gradient">Layanan Enterprise</h2>
        </div>
        <div className="tw-max-w-7xl tw-mx-auto tw-px-3 sm:tw-px-0">
          {dataSmnList.map((item, index) => (
            <div key={index} className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-6 tw-mb-10">
              {index % 2 === 0 ? (
                <>
                  <div className="tw-bg-white tw-rounded-xl tw-p-8 tw-shadow-sm tw-flex tw-flex-col tw-justify-center tw-order-2 md:tw-order-1">
                    <h2 className="tw-text-2xl md:tw-text-3xl tw-font-bold tw-text-teal-600 tw-mb-4">{item.title}</h2>
                    <p className="tw-text-gray-800 tw-text-base md:tw-text-lg">{item.description}</p>
                  </div>
                  <div className="tw-bg-gray-50 tw-rounded-xl tw-overflow-hidden tw-shadow-sm tw-order-1 md:tw-order-2">
                    <img src={item.image} alt="TikTok on smartphone" className="tw-w-full tw-h-full tw-object-cover tw-max-h-[330px]" />
                  </div>
                </>
              ) : (
                <>
                  <div className="tw-bg-gray-50 tw-rounded-xl tw-overflow-hidden tw-shadow-sm">
                    <img src={item.image} alt="TikTok on smartphone" className="tw-w-full tw-h-full tw-object-cover tw-max-h-[330px]" />
                  </div>
                  <div className="tw-bg-white tw-rounded-xl tw-p-8 tw-shadow-sm tw-flex tw-flex-col tw-justify-center">
                    <h2 className="tw-text-2xl md:tw-text-3xl tw-font-bold tw-text-teal-600 tw-mb-4">{item.title}</h2>
                    <p className="tw-text-gray-800 tw-text-base md:tw-text-lg">{item.description}</p>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;